export const enableKeyboardNavigation = () => {
    let focusableElements = [];
    let currentIndex = 0;
  
    const updateFocusableElements = () => {
      focusableElements = Array.from(document.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'))
        .filter(el => !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden'));
    };
  
    const focusElement = (index) => {
      if (focusableElements[index]) {
        focusableElements[index].focus();
      }
    };
  
    const handleKeyDown = (event) => {
      switch (event.key) {
        case 'ArrowUp':
        case 'ArrowLeft':
          event.preventDefault();
          currentIndex = (currentIndex > 0) ? currentIndex - 1 : focusableElements.length - 1;
          focusElement(currentIndex);
          break;
        case 'ArrowDown':
        case 'ArrowRight':
          event.preventDefault();
          currentIndex = (currentIndex + 1) % focusableElements.length;
          focusElement(currentIndex);
          break;
        case 'Tab':
          updateFocusableElements();
          break;
        case 'Enter':
          if (focusableElements[currentIndex]) {
            focusableElements[currentIndex].click();
          }
          break;
        default:
          break;
      }
    };
  
    document.addEventListener('keydown', handleKeyDown);
    updateFocusableElements();
  };